export default __webpack_public_path__ + "static/media/logo.853e2817.png";